export enum FeatureStatus
{
    Draft = 0,
    Pending = 1, 
    Active = 2,
    Expired = 3,
    Cancelled = 4,
    Voided = 5
}

export namespace FeatureStatus
{
    export const toString = ( value: FeatureStatus ) => [
        'Draft', 
        'Pending',
        'Active',
        'Expired',
        'Cancelled',
        'Voided'
    ][ value ];
}